import {makeActionCreator} from '../../redux-toolbelt';

export const settingDataInStoreAccordingToApiResponse = makeActionCreator<
  'settingDataInStoreAccordingToApiResponse',
  boolean
>('settingDataInStoreAccordingToApiResponse');
